import { jsx as _jsx } from "react/jsx-runtime";
import Save16 from '@carbon/icons-react/es/save/16';
import { Button } from '@rocketlane/ui';
export const SaveButton = (props)=>// eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ _jsx(Button, {
        variant: "primary",
        type: "button",
        rightIcon: /*#__PURE__*/ _jsx(Save16, {}),
        ...props
    });
